import {
    Dic
} from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const tableOption = function () {
    return {
        //   add: '新增',
        //   edit: '修改',
        view: '查看',
        page: true,
        selection: false,
        index: true,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewFormSlot: true,
        labelSuffix: '：',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '140px',
        menuAlign: 'center',
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 400,
        dialogWidth: '700px',
        emptyText: i18n.t('personAccess.title.noData'),
        menu: false,
        column: [{
                label: '位置',
                prop: 'areaName',
                overHidden: true,
                span: 12,
                search: true,
                searchSlot: true
            },
            {
                label: '设备名称',
                prop: 'deviceName',
                search: true,
                span: 12,
                formslot: true,

            },
            {
                label: '厂家/型号',
                prop: 'deviceVersion',
                span: 12
            },

            {
                label: '最近保养时间',
                prop: 'repairTime',
                span: 12,
                // search: true,
                // searchSlot: true

            },
            {
                label: '最近保养时间',
                prop: 'repairDate',
                span: 12,
                hide: true,
                search: true,
                searchSlot: true

            },
        ]
    }
}
export default tableOption